const config = {
  development: {
    appName: 'Vinne',
    lang: 'en',
    theme: 'base',
    firebase: {
      apiKey: 'AIzaSyBU25RAkVY9rcPXsSIzxGlMYn0GxL9WchQ',
      authDomain: 'vinne-test.firebaseapp.com',
      databaseURL: 'https://vinne-test.firebaseio.com',
      projectId: 'vinne-test',
      storageBucket: 'vinne-test.appspot.com',
      messagingSenderId: '189570714205',
      appId: '1:189570714205:web:86f20ed80ff06bdd499bb',
      measurementId: 'G-QQ6FGDYW03',
    },
    reduxFirebaseConfig: {
      userProfile: 'users',
      useFirestoreForProfile: true,
      useFirestoreForStorageMeta: true,
    },
  },
  local: {
    appName: 'Vinne',
    lang: 'en',
    theme: 'base',
    firebase: {
      apiKey: 'AIzaSyBzrx-4SETMTziaJVEPOqRmnXG4mkXTJDg',
      authDomain: 'vinne-local.firebaseapp.com',
      databaseURL: 'https://vinne-local.firebaseio.com',
      projectId: 'vinne-local',
      storageBucket: 'vinne-local.appspot.com',
      messagingSenderId: '416407966377',
      appId: '1:416407966377:web:2b2def01bf663843b74fb8',
    },
    reduxFirebaseConfig: {
      userProfile: 'users',
      useFirestoreForProfile: true,
      useFirestoreForStorageMeta: true,
    },
  },
  production: {
    appName: 'Vinne',
    lang: 'en',
    theme: 'base',
    firebase: {
      apiKey: 'AIzaSyApggbizCcl6aJYegmrFkjvN_yQ300fqBE',
      authDomain: 'vinne-prod.firebaseapp.com',
      databaseURL: 'https://vinne-prod.firebaseio.com',
      projectId: 'vinne-prod',
      storageBucket: 'vinne-prod.appspot.com',
      messagingSenderId: '200704429601',
      appId: '1:200704429601:web:6d1472566c5e4b0c73dd60',
      measurementId: 'G-1FV550EK72',
    },
    reduxFirebaseConfig: {
      userProfile: 'users',
      useFirestoreForProfile: true,
      useFirestoreForStorageMeta: true,
    },
  },
};

export default config;
